<template>
  <section id="projects" class="padded" v-show="showGrid">
    <Waterfall 
    :options="options" 
    class="grid--waterfall" 
    ref="projectGrid" 
    v-if="home && home[currentLang].thumbprojects">
      <div class="grid-sizer"></div>
        <WaterfallItem v-for="(project, index) in home[currentLang].thumbprojects" :key="project.uid" :class="defineClass(index)" :data-index="index">
            <router-link :to="{ path: definePath(project.uid) }" v-if="project.status == 'listed'">

               <ProjectThumb :title="project.title" :project='project' :currentLang="currentLang"/>
             
            </router-link>
          <ProjectThumb class="inactive" :title="project.title+' – Coming soon'" v-if="project.status == 'unlisted'" :project='project' :currentLang="currentLang"/>
        </WaterfallItem>
      </Waterfall>
      <div class="project-link">
        <button><router-link :to="{ path: getProjectsPagePath('ProjectsPage'), meta: {lang : currentLang} }">{{ buttonText }}</router-link></button>
      </div>
  </section>
</template>

<script>
import scrollBehavior  from '@/mixins/scrollBehavior.js'
import imagesLoaded from 'vue-images-loaded'

import {Waterfall, WaterfallItem} from 'vue2-waterfall';

const ProjectThumb = () => import( /* webpackChunkName: "ProjectThumb" */ '@/snippets/ProjectThumb.vue');

export default {
  props: ['currentLang', 'buttonText', 'home'],
  name: 'Projects',
  metaInfo: {
    title: 'Product Design Studio',
  },
  directives: {
      imagesLoaded
  },
  components:{
    ProjectThumb,
    Waterfall,
    WaterfallItem
  },
  methods: {
    detectSmallDevice(){
      this.isSmallDevice = window.innerWidth < 1024 ? true : false;
    },
    displayImage(e){
      let el = e.target;
      setTimeout(
        function(){ el.classList = 'loaded';
      }, 500);
    },
    definePath(uid){
      return this.currentLang == 'fr' ? 'fr/realisations/'+uid : 'work/'+uid;
    },
    getProjectsPagePath(routeName){
      let matchingRt = this.$router.options.routes.find(rt => rt.name === routeName);
      if(!matchingRt){
        return
      }
      return matchingRt.meta[this.currentLang+'Path']
    },
    defineClass(index){
      let $class = 'item';
      if((index+1) % 3 == 0 && (index+1) % 9 != 0 && (index+1) % 12 != 0 && (index+1) % 15 != 0){
        $class += ' item--50'
      }else if((index+1) % 13 == 0){
        $class += ' item--50'
      }else if((index+1) % 16 == 0){
        $class += ' item--50'
      }
      return $class;
    },
  },
  data(){
    return {
      showGrid: false,
      isSmallDevice: false,
      options: {
        "columnWidth": '.grid-sizer', 
        "itemSelector": ".item", 
        percentPosition: true
      }
    }
  },
  mixins: [scrollBehavior],
  watch:{
    visible(visible){
      if(visible){
        this.$refs.projectGrid.performLayout()
        this.showGrid = true;
      }
    },
  },
  mounted(){
    let self = this;
    setTimeout(function(){self.showGrid = true},1000);
    this.detectSmallDevice();
    window.addEventListener('resize', this.detectSmallDevice);
  }
}
</script>


<style lang="scss" scoped>
  #projects{
    padding-top:0;
    @media screen and (max-width:1200px){
      padding:1rem;
    }
    max-width:1600px;
    min-height:100vh;
    position:relative;
    margin:auto;
    .content{
      opacity:0;
      position:relative;
      @include transform(translate(0, 20%));
      @include transition(all .5s ease);
      &.display--grid{
        padding:0!important;
        opacity:1;
        @include transform(translate(0, 0));
        @media screen and (min-width:1200px){
          column-gap: 2rem;
        }
      }
    }
    .project-link{
      margin: 4.333rem 0 4.333rem;
      @media screen and (min-width: 1024px){
        margin-top: 6.666667rem;
        margin-bottom: 4.0666666667rem;
      }
      a{
        color: rgba(20, 20, 20, .5);
        &:hover{
          color: rgba(20, 20, 20, 1);
        }
      }
      button{
        font-family: 'surtregular', Helvetica, Arial, sans-serif;
        background: transparent;
        border: none;
        font-size: 1.2rem;
        text-transform: uppercase;
        margin:auto;
        color: inherit;
        display: block;
      }
    }
    .grid--waterfall{
      @media screen and (min-width:769px){
        margin: 0px -10px;
      }
    }

    .grid-sizer{
      width:25%;
    }

    .item{
      width:100%;
      padding:0 10px 10px;
      box-sizing: border-box;
      margin-bottom:30px;
      @media screen and (min-width:767px){
        width: 25%;
        margin-bottom:0;
         &.item--50{
          width:50%;
        }
      }
    }
  }
</style>
